export default __webpack_public_path__ + "static/media/city2.cf2a7ac3.jpg";